export const HOMEPAGE_ROUTE = '/';
export const NEWS_ROUTE = '/news';
export const CLIENTS_ROUTE = '/clients';
export const CLIENT_DETAILS_ROUTE = '/client-details';
export const CLIENT_DETAILS_BY_ID_ROUTE = '/clients/:id';
export const SIGNIN_ROUTE = '/signin';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
